import { EXPERIENCES } from './mock';

const img = (name) => EXPERIENCES.find((e) => e.name === name)?.img;

export const CUT_SEW_MINIMUM = '50 pieces per style / 50 pieces per color';

// Technique pages under /production/<slug>. Intros describe the technique only — no business claims.
export const TECHNIQUES = [
  { slug: 'screen-printing', name: 'Screen Printing', img: img('Screen Printing'),
    intro: 'Screen printing pushes ink through a fine mesh stencil, one color at a time, onto tees, hoodies and more. It produces bold, durable prints and is a go-to method for merch runs.' },
  { slug: 'embroidery', name: 'Embroidery', img: img('Embroidery'),
    intro: 'Embroidery stitches your logo or artwork directly into the garment with thread, giving hats, polos, jackets and heavyweight pieces a textured, premium finish.' },
  { slug: 'dtf-printing', name: 'DTF Printing', img: img('DTF Printing'),
    intro: 'DTF (direct-to-film) printing prints your full-color design onto a special film, then heat-presses it onto the garment — giving vibrant, detailed prints that work on cotton, polyester, blends and dark fabrics.' },
  { slug: 'dtg-printing', name: 'DTG Printing', img: img('DTG Printing'),
    intro: 'Direct-to-garment (DTG) printing works like an inkjet printer for fabric, reproducing full-color, highly detailed artwork without screens.' },
  { slug: 'cut-and-sew', name: 'Cut and Sew', img: img('Cut and Sew'), minimum: CUT_SEW_MINIMUM,
    intro: 'Cut and sew means building garments from the fabric up — your pattern, fit, fabric and details — instead of decorating a ready-made blank.' },
  { slug: 'sublimation', name: 'Sublimation', img: img('Sublimation'),
    intro: 'Sublimation turns dye into a gas that bonds with polyester fibers, creating vivid all-over prints that become part of the fabric itself.' },
  { slug: 'print-on-demand', name: 'Print-on-Demand', img: img('Print-on-Demand'),
    intro: 'Print-on-demand produces items as orders come in, so you can offer merch online without holding inventory up front.' },
  { slug: 'graphic-design', name: 'Graphic Design', img: img('Graphic Design'), minimum: 'Quoted per project', quotedPerProject: true,
    intro: 'Graphic design turns your ideas, logos and references into production-ready artwork built for the print method and garment you choose.' },
];

export const AUDIENCES = [
  { slug: 'artists-bands', name: 'Artists & Bands', to: '/artist-merch' },
  { slug: 'brands-companies', name: 'Brands & Companies', to: '/who-we-serve/brands-companies',
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/cjt10eb1_2.JPG',
    intro: 'Branded apparel and merchandise for teams, launches, campaigns and company events — produced with the techniques that fit your brand.' },
  { slug: 'clothing-brands', name: 'Clothing Brands', to: '/who-we-serve/clothing-brands',
    img: 'https://customer-assets.emergentagent.com/job_pusha-rebrand/artifacts/d43mij2o_cut-and-sew-factory.webp',
    intro: 'Production support for clothing labels — from decorated blanks to cut and sew pieces — so you can focus on design and growing your brand.',
    minimums: `Cut and sew: ${CUT_SEW_MINIMUM}. Screen printing, embroidery, DTF, DTG, sublimation and print-on-demand have no minimum. Typical turnaround is 7–10 days.` },
];

export const NAV = [
  { label: 'Production', to: '/production',
    children: [{ label: 'Full Production', to: '/production' }, ...TECHNIQUES.map((t) => ({ label: t.name, to: `/production/${t.slug}` }))] },
  { label: 'Who We Serve', children: AUDIENCES.map((a) => ({ label: a.name, to: a.to })) },
  { label: 'Work', to: '/work' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Live Events', to: '/live-events' },
  { label: 'Blog', to: '/blog' },
];

export const FOOTER_COLUMNS = [
  { title: 'Production', links: NAV[0].children },
  { title: 'Who We Serve', links: NAV[1].children },
  { title: 'Live Events', links: [
    { label: 'Live Event Printing', to: '/live-events' },
    { label: 'Live Printing Projects', to: '/work?type=live-printing' },
  ] },
  { title: 'Company', links: [
    { label: 'Work', to: '/work' },
    { label: 'Pricing', to: '/pricing' },
    { label: 'Blog', to: '/blog' },
  ] },
];

// Old hash links on the home page → new real pages.
export const LEGACY_HOME_HASHES = {
  '#services': '/production',
  '#case-studies': '/work',
  '#tailored-products': '/live-events',
  '#merch-booths': '/live-events',
  '#insights': '/blog',
};
